<form>
  <div class="fake-glxy-input-title">
    <div class="rich-text-title-text">
      {{ 'EMAIL_BUILDER.RICH_TEXT_BLOCK.RICH_TEXT' | translate }}
    </div>
    <div class="rich-text-buttons">
      @if (contentGenerationEnabled()) {
        <button
          mat-icon-button
          (click)="openSuggestAIContentDialog()"
          data-action="rich-text-clicked-generate-content"
          [glxyTooltip]="'EMAIL_BUILDER.CONTENT_SUGGESTION.INSERT_GENERATED_CONTENT' | translate"
        >
          <mat-icon svgIcon="galaxy-ai-icon" />
        </button>
      }
      <email-dynamic-component-selector [richTextEditorRef]="richTextEditor" [(model)]="content().rawHtml" />
    </div>
  </div>

  <email-rich-text-editor
    #richTextEditor
    [(value)]="content().rawHtml"
    (valueChange)="updateText()"
    (statusChange)="updateStatus($event)"
  />

  @if (isValid() === false) {
    <glxy-error>
      {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
    </glxy-error>
  }
</form>
